import { PartnerRowHourWorking } from 'components/PartnerView/PartnerRowHourWorking';
import { FormTitle } from 'components/Titles';
import { ChangeSrollCss } from 'helpers/utils';
import { IPartnerWorkingHours } from 'types/Partner';

import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

type IOpenHour = {
  openingHours?: IPartnerWorkingHours;
  borderOrange: string;
};

export const PartnerHourWork: React.FC<IOpenHour> = ({
  openingHours,
  borderOrange,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{ border: '2px solid', borderColor: borderOrange }}
    >
      <Box p={2}>
        <Grid container alignItems="flex-start">
          <Grid item container xs={12} md={12}>
            <FormTitle title="Horário de Funcionamento" />
          </Grid>
          <Grid width="100%" mb={3}>
            <TableContainer
              sx={{
                ...ChangeSrollCss,
                minHeight: 320,
                maxHeight: 320,
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>Dia</TableCell>
                    <TableCell>De</TableCell>
                    <TableCell>Até</TableCell>
                    <TableCell>Intervalo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(openingHours ?? {}).map(
                    ([day, value], index) => {
                      return (
                        <PartnerRowHourWorking
                          key={index}
                          day={day}
                          value={value}
                        />
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* <Grid item container xs={12} md={12} justifyContent="flex-end">
            <Button sx={{ paddingX: 4 }} onClick={() => alert('Edição')}>
              editar
            </Button>
          </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
};

